import * as React from 'react';
import StarRateRoundedIcon from '@material-ui/icons/StarRateRounded';
import styles from './StaffPick.module.css';

/**
 * Staff Pick (featured product pill)
 */
const StaffPick = ({withStar}) => {
  
  // Extra left padding when star is present
  const starStyle = withStar ? {paddingLeft:'.75rem'}  : {};

  return ( 
    <div className={styles.staffPick} style={starStyle}>
      <span className={styles.pillText}>Staff&nbsp;Pick</span>
      { withStar && 
        <StarRateRoundedIcon style={{fontSize:'20px', verticalAlign:'-6px'}} />
      }
    </div>
  )
}

export default StaffPick;